<template>
    <v-container 
      :class="!showSearchBox?'pb-1 pt-1 pl-0 ml-0 pr-0 mr-0 fluid':'pb-1 pt-1 fluid'" 
      :style="'padding:0;'">        
        
        <v-layout row wrap v-show="showSearchBox && !showMulticity" 
          :style="'border-bottom:solid 2px #e6e6e6'">
            <v-flex md6 xs12>
                <v-layout row wrap>
                    <v-flex md6 xs12>
                        <AirportSelector 
                          :disabled="searchBoxControlsDisabilities.originSelector" 
                          :setAirport="storedSearchBoxValues.origin" 
                          :cityAirports="cityAirports" 
                          @airportSelected="airport => searchPara.origin=airport" 
                          icon="flight_takeoff"/>
                    </v-flex>
                    <v-flex md6 xs12>
                        <AirportSelector 
                          :disabled="searchBoxControlsDisabilities.destinationSelector" 
                          :setAirport="storedSearchBoxValues.destination" 
                          :cityAirports="cityAirports" 
                          @airportSelected="airport => searchPara.destination=airport" 
                          icon="flight_land"/>                
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex md1 xs12>
                <AirlineSelector 
                  :disabled="searchBoxControlsDisabilities.airlineSelector" 
                  :airlines="airlines" 
                  :setAirline="storedSearchBoxValues.airline" 
                  @emSelectedAirline="a=>searchPara.airline=a"></AirlineSelector>
            </v-flex>
            <v-flex md5 xs12>
                <v-layout row wrap>
                    <v-flex md6 xs12>
                        <v-layout row wrap>
                            <v-flex md6 xs12>
                                <v-menu class="hundred-percent-width">
                                    <v-text-field
                                        label="Departure"
                                        slot="activator"
                                        prepend-icon="date_range"
                                        :value="searchPara.departureDate"
                                        :disabled="searchBoxControlsDisabilities
                                          .dateOfDeparturePicker"
                                    ></v-text-field> 
                                    <v-date-picker 
                                      :disabled="searchBoxControlsDisabilities
                                        .dateOfDeparturePicker" 
                                        @input="departureDateChanged" 
                                        v-model="searchPara.departureDate"></v-date-picker>
                                </v-menu>
                            </v-flex>  
                            <v-flex md6 xs12>
                                <v-menu class="hundred-percent-width" 
                                  :disabled="!this.P_TripType">
                                    <v-text-field
                                        label="Return"
                                        slot="activator"
                                        :prepend-icon="this.P_TripType? 
                                          'date_range':'lock'"
                                        :value="this.P_TripType? 
                                          searchPara.returnDate:null"
                                        :disabled="!this.P_TripType||
                                          searchBoxControlsDisabilities.dateOfReturnPicker"
                                    ></v-text-field> 
                                    <v-date-picker :disabled="!this.P_TripType||
                                      searchBoxControlsDisabilities.dateOfReturnPicker" 
                                      v-model="searchPara.returnDate"></v-date-picker>
                                </v-menu>            
                            </v-flex>  
                        </v-layout>
                    </v-flex>

                    <v-flex md6 xs12>
                        <v-layout>
                            <v-flex md7 xs12 pr-1>
                                <PassengerBox
                                :setPassengerCountByPax="storedSearchBoxValues
                                  .passengerCountByPax"
                                @seatClassSelected="c=>searchPara.seatClass=c"
                                @passengerCounts="pc=>getPassengerCounts(pc)"
                                :disabled="searchBoxControlsDisabilities.passengerPicker"
                                />     
                            </v-flex>           
                            <v-flex md5 xs12>
                                <v-btn :disabled="searchBoxControlsDisabilities.searchButton" 
                                color="primary" 
                                class="trimmed-button hundred-percent-width" 
                                @click="submitSearch(searchPara);">Search</v-btn>         
                            </v-flex>                   
                        </v-layout>                    
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-alert :value="validation.showAlert" 
              type="error" :style="'width:100%;'">{{validation.message}}</v-alert>
        </v-layout>
        
        <v-layout v-show="!showSearchBox" row wrap>
            <v-flex md12>
                <v-layout row>
                    <v-spacer v-if="!isMobile"></v-spacer>
                    <v-flex md2>
                        <v-btn-toggle style="background:transparent;" multiple>
                            <v-btn flat class="pt-2" 
                              :href="backToHomeUrl">
                                <v-icon>home</v-icon>&nbsp;&nbsp;Home
                            </v-btn>
                            <v-btn flat @click="copyLink" 
                              class="pt-2" :disabled="searchBoxControlsDisabilities
                                .copyLinkButton"><v-icon>link</v-icon>&nbsp;Copy Link
                            </v-btn>
                        </v-btn-toggle>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex md12>
                <v-card flat color="primary" dark class="pl-4 pr-4">
                    <v-card-text>
                    <v-layout row> 
                        <v-flex xs11 md11>
                            <v-layout row wrap>
                                <v-flex md6>
                                    <v-layout row wrap>
                                        <v-flex md6>
                                          <span>From: {{searchPara.origin}}</span></v-flex>
                                        <v-flex md6>
                                          Departure: {{searchPara.departureDate}}</v-flex>
                                        <v-flex md6>
                                          To: {{searchPara.destination}}</v-flex>
                                        <v-flex md6>
                                          Return: {{this.P_TripType? searchPara.returnDate:''}}</v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex md6>
                                    <v-layout row wrap>
                                        <v-flex md12>{{selectedSeatClass}}</v-flex>                                        
                                        <v-flex md12>
                                            <label>{{searchPara.adtPassengerCount!=0? 
                                              'Adults:'+ searchPara.adtPassengerCount:''}}
                                            </label>
                                            <label class="ml-2">
                                              {{searchPara.cnnPassengerCount!=0? 'Children:'+ 
                                                searchPara.cnnPassengerCount:''}}</label>
                                            <label class="ml-2">
                                              {{searchPara.infPassengerCount!=0? 'Infants:'+ 
                                                searchPara.infPassengerCount:''}}</label>
                                            <label class="ml-2">
                                              {{searchPara.stuPassengerCount!=0? 'Student:'+ 
                                                searchPara.stuPassengerCount:''}}</label>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1 md1>
                            <v-btn small 
                              :color="defaultColors.secondary" fab 
                              @click="lnkedit()"><v-icon>edit</v-icon></v-btn>
                        </v-flex>                        
                    </v-layout>                        
                    </v-card-text>

                </v-card>
            </v-flex>
        </v-layout>
        <v-progress-linear v-if="indeterminate" 
          :indeterminate="indeterminate"></v-progress-linear>
    <v-dialog
      v-model="showCopyLinkDialog"
      width="500"
      height="300"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Copy link
        </v-card-title>

        <v-card-text>
            <v-textarea :value="linkToCopy" 
              outline background-color="#808080"></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="copyLinkDialogClick()"
            v-clipboard:copy="linkToCopy"
            v-clipboard:success="onCopyToClipboard"
            v-clipboard:error="onCopyToClipboardErr"
          >
            Copy
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>        
        <v-snackbar
            :top="true"
            :timeout="3000"
            v-model="snackbar.show"
            class="text-md-center"
            color="#ce971c"
        >{{snackbar.text}}
            <v-btn
                color="white"
                flat
                @click="snackbar.show = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import SearchBox from './SearchBox.code.js'
export default SearchBox;
</script>

<style>
.hundred-percent-width{
    width: 100%;
}
.trimmed-button{
    margin-left: 0px;
    margin-right: 0px;
}
.number-of-passenger{
    width:100%;
    text-align: center;
}
</style>
